import { render, staticRenderFns } from "./tgTurntable.vue?vue&type=template&id=5fdffaf7&"
import script from "./tgTurntable.vue?vue&type=script&lang=js&"
export * from "./tgTurntable.vue?vue&type=script&lang=js&"
import style0 from "./tgTurntable.vue?vue&type=style&index=0&id=5fdffaf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports